import { render, staticRenderFns } from "./DebtorsTable.vue?vue&type=template&id=e952045a&scoped=true&"
import script from "./DebtorsTable.vue?vue&type=script&lang=js&"
export * from "./DebtorsTable.vue?vue&type=script&lang=js&"
import style0 from "./DebtorsTable.vue?vue&type=style&index=0&id=e952045a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e952045a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
